import React from 'react';
import { Users, TrendingUp, Trophy, BellRing, BoxIcon } from 'lucide-react';
interface KpiCardProps {
  label: string;
  value: string | number;
  subtitle: string;
  accent?: 'wood' | 'green' | 'red';
  icon?: BoxIcon;
}
function KpiCard({
  label,
  value,
  subtitle,
  accent,
  icon: Icon
}: KpiCardProps) {
  const valueColor = accent === 'wood' ? 'text-wood' : accent === 'green' ? 'text-green' : accent === 'red' ? 'text-red' : 'text-charcoal';
  const iconBg = accent === 'wood' ? 'bg-wood/10 text-wood' : accent === 'green' ? 'bg-green/10 text-green' : accent === 'red' ? 'bg-red/10 text-red' : 'bg-charcoal/5 text-charcoal-soft';
  return <div className="bg-white border border-line rounded-2xl p-4 shadow-card hover:shadow-lg transition-shadow relative overflow-hidden group" data-id="element-48">
      <div className="flex items-start justify-between mb-3" data-id="element-49">
        <div className="text-[11px] font-extrabold text-[#8a8175] uppercase tracking-wider leading-tight" data-id="element-50">
          {label}
        </div>
        {Icon && <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${iconBg}`} data-id="element-51">
            <Icon className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-52" />
          </div>}
      </div>
      <div className={`font-poppins font-black text-[26px] md:text-[28px] leading-none tracking-tight ${valueColor}`} data-id="element-53">
        {value}
      </div>
      {subtitle && <div className="text-[11.5px] text-[#8a8175] mt-1.5 font-semibold" data-id="element-54">
          {subtitle}
        </div>}
    </div>;
}
interface KpiGridProps {
  kpis: Array<{
    label: string;
    value: string | number;
    subtitle: string;
    accent?: 'wood' | 'green' | 'red';
    icon?: BoxIcon;
  }>;
}
export function KpiGrid({
  kpis
}: KpiGridProps) {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5" data-id="element-55">
      {kpis.map((kpi, i) => <KpiCard key={i} {...kpi} data-id="element-56" />)}
    </div>;
}
export { Users, TrendingUp, Trophy, BellRing };